import { AccountCreation } from '@/components/signup/account-creation/account-creation.tsx';
import { LoomOverlayTemplate } from '@/components/signup/layouts/product-overlay-template.tsx';

import { GetStartedText } from '../../components/get-started-heading.tsx';
import { Headings } from '../../components/headings.tsx';
import { FreeForTenUsersText } from '../../components/sub-heading.tsx';
import { InputSubmitButton } from '../../components/submit-input.tsx';

export const LoggedOutLoom = () => {
	return (
		<LoomOverlayTemplate size="sm">
			<Headings main={<GetStartedText productName="Loom" />} sub={<FreeForTenUsersText />} />
			<AccountCreation Input={<InputSubmitButton />} Submit={null} />
		</LoomOverlayTemplate>
	);
};
